import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Assert from '../util/Assert';
var GraphComponent = /*#__PURE__*/function () {
  function GraphComponent() {
    _classCallCheck(this, GraphComponent);
    GraphComponent.constructor_.apply(this, arguments);
  }
  _createClass(GraphComponent, [{
    key: "setVisited",
    value: function setVisited(isVisited) {
      this._isVisited = isVisited;
    }
  }, {
    key: "setInResult",
    value: function setInResult(isInResult) {
      this._isInResult = isInResult;
    }
  }, {
    key: "isCovered",
    value: function isCovered() {
      return this._isCovered;
    }
  }, {
    key: "isCoveredSet",
    value: function isCoveredSet() {
      return this._isCoveredSet;
    }
  }, {
    key: "setLabel",
    value: function setLabel(label) {
      this._label = label;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this._label;
    }
  }, {
    key: "setCovered",
    value: function setCovered(isCovered) {
      this._isCovered = isCovered;
      this._isCoveredSet = true;
    }
  }, {
    key: "updateIM",
    value: function updateIM(im) {
      Assert.isTrue(this._label.getGeometryCount() >= 2, 'found partial label');
      this.computeIM(im);
    }
  }, {
    key: "isInResult",
    value: function isInResult() {
      return this._isInResult;
    }
  }, {
    key: "isVisited",
    value: function isVisited() {
      return this._isVisited;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._label = null;
      this._isInResult = false;
      this._isCovered = false;
      this._isCoveredSet = false;
      this._isVisited = false;
      if (arguments.length === 0) {} else if (arguments.length === 1) {
        var label = arguments[0];
        this._label = label;
      }
    }
  }]);
  return GraphComponent;
}();
export { GraphComponent as default };